export default {
  name: 'moral-guidance',
  created () {
    this.search()
  },
  data () {
    return {
      callbackFlag: false
    }
  },
  computed: {
    moralResult () {
      return this.$store.getters.moralResult
    }
  },
  methods: {
    goMoralStart: function () {
      this.$router.push({ path: '/moral_start'})
    },
    goMoralCheck: function () {
      if (this.moralResult.attributes['is-all-answered'] == 1) {
        this.$router.push({ path: '/moral_check_list/'})
      } else {
        this.$router.push({ path: '/moral_check/999'})
      }
    },
    search: function () {
      var self = this
      var data = {}
      var callback = function() {
        self.callbackFlag = true
      }
      this.$store.dispatch('MORAL_GET',  {id: window.localStorage.getItem('user_id'), data: data, callback: callback})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral-guidance.js